export default {

    namespaced: true,

    state: {
        // properties we care about
        avatars_v2_enabled: false,
        switch_profile_pin_enabled: false,

        // for others refer to Core's Feature.php
    },

    mutations: {
        setAvatarsFlagV2: function (state, flag) {
            state.avatars_v2_enabled = flag;
        },
        setFeatureFlags: function (state, features) {
            Object.keys(features).sort().forEach(( feature) => {
                state[feature] = features[feature];
            });
        },
    },

    actions: {},

    getters: {
        // alias for isEnabled
        isActive: (state, getters) => (featureFlag) => {
            return getters.isEnabled(featureFlag);
        },
        isEnabled: state => (featureFlag) => {
            return state[featureFlag] ? state[featureFlag] : false;
        },
        getFlagAvatar: state => {
            return state.avatars_v2_enabled;
        },
        requirePinToSwitchProfile: state => {
            return state.switch_profile_pin_enabled
        },
    }

}
